import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import Logo from '../assets/VSS-LOGO-2.jpg';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) {
      setIsAboutDropdownOpen(false);
    }
  };

  const toggleAboutDropdown = (e) => {
    e.stopPropagation();
    setIsAboutDropdownOpen(!isAboutDropdownOpen);
  };

  const closeMenus = () => {
    setIsMenuOpen(false);
    setIsAboutDropdownOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <img src={Logo} alt="VVS Logo" className={styles.logoImage} />
      </div>
      <nav className={styles.nav}>
  <input
    type="checkbox"
    id="menu-toggle"
    className={styles.menuToggle}
    checked={isMenuOpen}
    onChange={toggleMenu}
  />
  <label htmlFor="menu-toggle" className={styles.menuIcon}>
    <span className={styles.bar}></span>
    <span className={styles.bar}></span>
    <span className={styles.bar}></span>
  </label>
  <ul className={`${styles.menu} ${isMenuOpen ? styles.open : ''}`}>
    <li><Link to="/" onClick={closeMenus}>🏠 Home</Link></li>

    {/* About Us Dropdown */}
    {/* Ensure dropdown has the 'open' class for mobile to show content */}
    <li className={`${styles.dropdown} ${isAboutDropdownOpen ? styles.open : ''}`}>
      <span
        className={styles.dropbtn}
        onClick={toggleAboutDropdown}
      >
        ℹ️ About<i className="fas fa-caret-down"></i>
      </span>
      <ul className={styles.dropdownContent}>
        <li><Link to="/about" onClick={closeMenus}>📖 About Us (Main)</Link></li>
        <li><Link to="/committee" onClick={closeMenus}>🤝 Committee</Link></li>
        <li><Link to="/annual-report" onClick={closeMenus}>📊 Reports</Link></li>
      </ul>
    </li>

    <li><Link to="/achievements" onClick={closeMenus}>🏆 Achievements</Link></li>
    <li><Link to="/special-school" onClick={closeMenus}>🏫 Special School</Link></li>
    <li><Link to="/workshop" onClick={closeMenus}>🛠️ Workshop</Link></li>
    <li><Link to="/media" onClick={closeMenus}>📰 Media</Link></li>
    <li><Link to="/gallery" onClick={closeMenus}>🖼️ Photos</Link></li>
    <li><Link to="/video-gallery" onClick={closeMenus}>🎬 Videos</Link></li>
    <li><Link to="/certificates" onClick={closeMenus}>📜 Certificates</Link></li>
    <li><Link to="/contact" onClick={closeMenus}>📞 Contact</Link></li>
  </ul>
</nav>
      <Link to="/donate" className={styles.donateButton} onClick={closeMenus}>
        Donate Us
      </Link>
    </header>
  );
}

export default Header;